import React from "react";
import { GetFastQuote } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Link from "next/link";

interface GetFastQuoteProps {
  blok?: GetFastQuote & SbBlokData;
}

const GetFastQuoteComponent: React.FC<GetFastQuoteProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, cta_button, cta_button_link } = blok;

  return (
    <div className="numbers-bg-section py-4" {...storyblokEditable(blok)}>
      <div className="container">
        <div className="d-flex text-center text-lg-start flex-column flex-md-row align-items-center justify-content-center">
          {title && (
            <h2 className="text-white mb-3 h3 me-3 mb-lg-0">{title}</h2>
          )}
          {cta_button && cta_button_link?.url && (
            <Link
              className="button button-medium button-primary js-cta-button"
              href={cta_button_link.url}
            >
              {cta_button}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default GetFastQuoteComponent;
